const auth0State = {
    authConnection: undefined,
    authConnectionError: undefined,
    authConnections: undefined,
    requestingAuthConnection: false,
    requestingAuthConnections: false,
    requestingRemoveServerSideCookie: false,
    requestingSetServerSideCookie: false
};
export default auth0State;
